import * as React from 'react';
import { Dispatch } from 'redux';
import { CreateGeneratorJobRequestForLiveAndHybrid as FormData } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class CreateGeneratorJobRequestForLiveAndHybrid extends BaseApiPostRequest<
  ParticipantNormalizers.NormalizedParticipantsSampleView,
  EntityNormalizers.NormalizedSingleEntity<ParticipantNormalizers.NormalizedParticipantsSampleView>
> {
  constructor(formData: FormData, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/producer/clips/render`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipantSample;
  }
}
